import { FormHandle } from '@/hooks/use-form-handle.hook';
import { FC } from 'react';
import InputControl from '@/components/form/input-control';
import { isWriteMode, ViewMode } from '@/lib/helpers';
import { Box, Stack } from '@mui/material';
import { ConnectorModel } from '@/lib/models/connector/connector.model';
import { NetskopeConnectorModel } from '@/lib/models/connector/netskope-connector.model';
import Text from '@/components/text';
import TextInput from '@/components/form/text-input';
import NoneChip from '@/components/chip/none-chip';
import ConnectorStepCard from './connector-step-card';

interface Props {
  connector: NetskopeConnectorModel;
  formHandle: FormHandle<ConnectorModel>;
  mode: ViewMode;
}

const NetskopeConnector: FC<Props> = ({ formHandle, mode, connector }) => {
  const inWriteMode = isWriteMode(mode);
  const { catalogUrl } = connector.config;

  return (
    <>
      {inWriteMode && (
        <Box>
          <InputControl name="config.tenantInfo" label="Tenant Info" formHandle={formHandle} />

          <InputControl
            name="config.xAuthenticatedUserEnabled"
            label="Enable X-Authenticated-User Header"
            formHandle={formHandle}
            type="switch"
          />
        </Box>
      )}

      {!inWriteMode && (
        <Box mt={2}>
          <ConnectorStepCard title="Deployment">
            <Stack gap={2}>
              <Text bold>Catalog URL</Text>
              {catalogUrl ? (
                <TextInput
                  name="catalogUrl"
                  disabled
                  copyClip
                  value={catalogUrl}
                  fullWidth
                  size="x-small"
                />
              ) : (
                <NoneChip />
              )}
            </Stack>
          </ConnectorStepCard>
        </Box>
      )}
    </>
  );
};

export default NetskopeConnector;
